import React, { useState } from 'react';
import { Activity, Plus, RotateCcw } from 'lucide-react';

export function Counter() {
  const [currentCount, setCurrentCount] = useState(0);

  const incrementCounter = () => {
    setCurrentCount((prev) => prev + 1);
  };

  const resetCounter = () => {
    setCurrentCount(0);
  };

  return (
    <div className="max-w-xl mx-auto space-y-6">
      <div className="bg-[#11131a] border border-slate-800 rounded-md p-6 shadow-sm">
        <div className="flex items-center space-x-3 mb-4">
          <div className="p-2 rounded bg-indigo-500/10 border border-indigo-500/30 text-indigo-400">
            <Activity className="w-5 h-5" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-slate-100">State & Counter Diagnostics</h1>
            <p className="text-xs text-slate-400">Verification component for client-side React rendering</p>
          </div>
        </div>

        <div className="bg-[#090a0f] border border-slate-800/80 rounded p-6 my-6 text-center">
          <span className="text-xs uppercase tracking-wider font-mono text-slate-500 block mb-2">
            Atomic State Count
          </span>
          <span className="font-mono text-5xl font-bold text-slate-100 tracking-tight" aria-live="polite">
            {currentCount}
          </span>
        </div>

        <div className="flex items-center space-x-3 pt-2">
          <button
            type="button"
            className="inline-flex items-center space-x-1.5 rounded-md px-3.5 py-1.5 text-xs font-medium uppercase tracking-wide bg-indigo-600 hover:bg-indigo-500 text-white transition-colors focus:outline-none focus:ring-1 focus:ring-indigo-500/50"
            onClick={incrementCounter}
          >
            <Plus className="w-3.5 h-3.5" />
            <span>Increment</span>
          </button>

          <button
            type="button"
            className="inline-flex items-center space-x-1.5 rounded-md px-3.5 py-1.5 text-xs font-medium uppercase tracking-wide bg-[#1a1d27] hover:bg-slate-800 text-slate-300 border border-slate-700 transition-colors focus:outline-none"
            onClick={resetCounter}
          >
            <RotateCcw className="w-3.5 h-3.5" />
            <span>Reset</span>
          </button>
        </div>
      </div>
    </div>
  );
}
